import request from '@/utils/'

let aixosurl = ''
if (process.env.NODE_ENV == 'development') {
  aixosurl = ''
} else if (process.env.NODE_ENV != 'production') {
  aixosurl = '/LifeRighs'
} else {
  aixosurl = '/LifeRights'
}

export const loginCoupon = params => {
  return request({
    method: 'POST',
    url: aixosurl + '/coupon/auth/login',
    data: {
      mobile: params.mobile,
      verifyCode: params.secret
    }
  }).then(res => {
    // 兼容旧页面：返回 { data: { token } }
    const accessToken = res.data && res.data.data ? res.data.data.accessToken : ''
    return { data: { token: accessToken } }
  })
}

export const getCouponCategories = () => {
  return request({
    method: 'GET',
    url: aixosurl + '/coupon/api/categories'
  }).then(res => ({ data: res.data.data || [] }))
}

export const getCouponsByCategory = ({ categoryId }) => {
  return request({
    method: 'GET',
    url: aixosurl + '/coupon/api/list',
    params: { categoryId }
  }).then(res => ({ data: res.data.data || [] }))
}

export const getCouponDetail = ({ id }) => {
  return request({
    method: 'GET',
    url: aixosurl + '/coupon/api/detail',
    params: { id }
  }).then(res => ({ data: res.data.data || { id } }))
}

export const claimCoupon = ({ couponId }) => {
  return request({
    method: 'POST',
    url: aixosurl + '/coupon/api/claim',
    data: { couponId }
  }).then(res => ({ data: !!(res.data && res.data.data) }))
}

export const getClaimedCoupons = () => {
  return request({
    method: 'GET',
    url: aixosurl + '/coupon/api/claimed'
  }).then(res => ({ data: res.data.data || [] }))
}
